import {combineReducers, createStore, applyMiddleware, compose} from "redux";
import {persistStore, persistReducer} from 'redux-persist';
import thunk from "redux-thunk";
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

// reducers
import states from './reducers/states'
import user from './reducers/user'
import alerts from './reducers/alerts'
import session from './reducers/session'
import projectLeads from "./reducers/projectLeads"
import indicativeOptionData from "./reducers/indicativeOptionData"
import formFlow from "./reducers/formFlow"
import infoFeed from "./reducers/infoFeed"
import applicationData from "./reducers/applicationData"

export const rootReducer = combineReducers({
    states,
    user,
    alerts,
    session,
    projectLeads,
    indicativeOptionData,
    formFlow,
    infoFeed,
    applicationData
});

const persistConfig = {
    key: 'root',
    storage,// new CookieStorage(Cookies/*, options */),
    stateReconciler: autoMergeLevel2, // see docs on merge process. This tracks changes several layers deep in the keys
    blacklist: [alerts],
};

const pReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(pReducer, /* preloadedState, */ composeEnhancers(
    applyMiddleware(thunk)
));

export const persistor = persistStore(store);
